import React from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';

import Modal from 'components/Modal';

const modalProps = {
  content: {
    width: '90%',
    maxWidth: 440,
    padding: '20px 16px',
    borderRadius: 12,
  },
};

const UnitDescriptionModal = ({ modalIsOpen, toggleModal, name, description }) => (
  <Modal
    closeOnOverlayClick={false}
    closeOnEsc={false}
    modalProps={modalProps}
    modalIsOpen={modalIsOpen}
    closeModal={toggleModal}
    closeable={false}
  >
    <section className="unit-description-modal">
      <MdClose className="unit-description-modal__closeicon" onClick={toggleModal} />
      <h3>{name}</h3>
      <p>{description}</p>
    </section>
  </Modal>
);

UnitDescriptionModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default UnitDescriptionModal;
